import { NoRealData } from "@/components/shared";

export default function Responsabilidades() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold text-foreground-900">Responsabilidades e Restrições</h1>
        <p className="text-sm text-foreground-500 mt-1">Gestão de direitos, deveres e restrições legais</p>
      </div>
      <NoRealData
        variant="page"
        icon="ri-shield-check-line"
        title="Responsabilidades e restrições (RRR)"
        description="Registro de responsabilidades administrativas e restrições ambientais (APP, tombamento) conforme LADM-FloraIQ. A tela ainda não está ligada a uma fonte real."
      />
    </div>
  );
}
